import {HTMLElement, con, def, dis} from '@acng/frontend-bounty/dom/custom.js';
import {Watch} from '@acng/frontend-relativity';
import {Engine, ElementSetup} from '@acng/frontend-stargazer';

import {inject} from '../../core/service/ng.js';
import {ctxMovie} from '../context/movie.js';
import {compile} from '../service/template.js';

export const MOVIE_DETAIL = 'movie-detail';

ElementSetup(MOVIE_DETAIL, (name) => {
  const watchGallery = Watch(name, ctxMovie);
  const transclude = Engine.Transclude(name);
  const unitFilter = inject('unitFilter');

  class MovieDetail extends HTMLElement {
    #linker = Engine.root;

    [con]() {
      const linker = transclude(this);

      watchGallery(this, (element, movie) => {
        linker.toElement(element, {
          description: movie.getDescription() ?? '',
          width: movie.width,
          height: movie.height,
          playtime: unitFilter(movie.playtime, 'sec'),
          filesize: unitFilter(movie.filesize, 'byte'),
        });
      });

      this.#linker = linker;
    }

    [dis]() {
      this.#linker.disconnect();
    }
  }

  def(name, MovieDetail);

  return compile;
});
